import { RoutingConfig } from '@spartacus/core'
import { MB_PRODUCT_DETAILS_URL_MATCHER } from '../../url-matchers/product-details-page/product-details-urls-matcher'

export const mbProductRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      product: {
        matchers: [MB_PRODUCT_DETAILS_URL_MATCHER],
        paths: [
          'products/:productCode'
        ],
        paramsMapping: { productCode: 'urlEncodedName' }
      },
    }
  },
}

